import React, { useRef, useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import DocumentMeta from "react-document-meta";

import { SocialCue } from "./Cue";
import Layout from "../Layout";
import { H2RHeading } from "../imports";
import AddSocialCommentModal from "./modal/AddSocialCommentModal";
import { H2RButton } from "../imports";
import AddDataSourceModal from "./modal/AddDataSourceModal";
import { removeDataSourceMessages } from "../../api/cue";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddDataSource from "./AddDataSource";

function useQuery() {
	const { search } = useLocation();

	return useMemo(() => new URLSearchParams(search), [search]);
}

export default function Social({ navbar = true }) {
	const [showChat, setShowChat] = useState(true);
	const [showList, setShowList] = useState(true);
	const [showRealtime, setShowRealtime] = useState(true);
	const [mod, setMod] = useState(false);
	const [activeChatMessage, setActiveChatMessge] = useState("");
	const [prompter, setPrompter] = useState(false);
	const [showAddCommentModal, setShowAddCommentModal] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [hideButtons, setHideButtons] = useState(false)

	let { projectId } = useParams();
	let query = useQuery();

	const selectedProject = useSelector(
		(state) => state.main.projects?.[projectId]
	);
	const dataSources = useSelector((state) => state.main?.dataSources) || {};

	const meta = {
		title: `Social - ${selectedProject?.name}`,
	};

	const autoScrollParent = useRef();
	const autoScrollSpan = useRef();

	useEffect(() => {
		if (autoScrollSpan.current) {
			autoScrollSpan.current.scrollIntoView({ behavior: "smooth" });
		}
	}, [dataSources]);

	useEffect(() => {
		if (selectedProject && selectedProject.cues) {
			let actives = [];
			selectedProject.cues?.map((cue) => {
				if (cue.type !== "social") return null;

				if (cue.status === "onair" || cue.status === "coming") {
					// setActiveChatMessge(cue);
					actives.push(cue);
				}

				return setActiveChatMessge(actives);
			});
		}
	}, [selectedProject]);

	useEffect(() => {
		let q = query.get("moderator");
		if (q === "true") {
			setMod(true);
		}
		let c = query.get("showChat");
		if (c === "false") {
			setShowChat(false);
		} else {
			setShowChat(true);
		}

		let l = query.get("showList");
		if (l === "false") {
			setShowList(false);
		} else {
			setShowList(true);
		}

		let a = query.get("showRealtime");
		if (a === "false") {
			setShowRealtime(false);
		} else {
			setShowRealtime(true);
		}

		let promp = query.get("prompter");
		if (promp === "true") {
			setPrompter(true);
		} else {
			setPrompter(false);
		}

		let b = query.get("hideButtons");
		if (b === "true") {
			setHideButtons(true);
		} else {
			setHideButtons(false);
		}
	}, [query]);

	// console.log(
	// 	Object.entries(dataSources).filter(([id, source]) => {
	// 		return source.addedToProjects?.includes(projectId);
	// 	}).length
	// );

	if (selectedProject === undefined) {
		return null;
	} else {
		return (
			<DocumentMeta {...meta}>
				<Layout navbar={navbar} bgColor={prompter ? "bg-black" : "bg-gray-900"}>
					<section className={`mx-5 my-5 flex flex-col flex-1`}>
						{/* <div className="flex justify-between mb-4">
							 <H2RHeading type="h5">Social - {selectedProject.name}</H2RHeading> 
						</div> */}
						<AddDataSourceModal
							open={
								Object.entries(dataSources).filter(([id, source]) =>
									source.addedToProjects?.includes(projectId)
								).length < 1
							}
							onClose={() => {}}
							closeable={true}
						/>
						<div className="pb-2 flex justify-end space-x-2">
							
							{query.get("showChat") !== "false" && (
								<label
									className="px-2 py-1 border border-gray-800 bg-gray-800 rounded cursor-pointer"
									htmlFor="toggleChat"
								>
									<input
										type="checkbox"
										checked={showChat}
										onChange={(e) => {
											setShowChat(e.target.checked);
										}}
										name="toggleChat"
										id="toggleChat"
									/>
									<span className="ml-2">Chat</span>
								</label>
							)}

							{query.get("showList") !== "false" && (
								<label
									className="px-2 py-1 border border-gray-800 bg-gray-800 rounded cursor-pointer"
									htmlFor="toggleList"
								>
									<input
										type="checkbox"
										checked={showList}
										onChange={(e) => setShowList(e.target.checked)}
										name="toggleList"
										id="toggleList"
									/>
									<span className="ml-2">List</span>
								</label>
							)}

							{query.get("showRealtime") !== "false" && (
								<label
									className="px-2 py-1 border border-gray-800 bg-gray-800 rounded cursor-pointer"
									htmlFor="toggleRealtime"
								>
									<input
										type="checkbox"
										checked={showRealtime}
										onChange={(e) => setShowRealtime(e.target.checked)}
										name="toggleRealtime"
										id="toggleRealtime"
									/>
									<span className="ml-2">Realtime</span>
								</label>
							)}

						{!hideButtons && <H2RButton
							text="Clear all messages"
							size="small"
							colour="dark"
							disabled={dataSources.length === 0}
							onClick={() => {
								if(dataSources.length === 0) return
								removeDataSourceMessages(Object.entries(dataSources || []).filter(([id, source])=> source.addedToProjects.includes(projectId))[0])
							}}
						/>}
						</div>
						<div
							className="flex flex-row flex-grow"
							style={{ overflow: "hidden" }}
						>
							{showChat && (
								<div
									className={`px-2 pt-1 flex flex-col space-y-2 bg-gray-900
												${!showList && !showRealtime ? "w-100" : "w-1/2"}
								`}
								>
									<div className="flex items-end space-x-2 w-full">
										<H2RHeading type="h6">Chat</H2RHeading>
										{searchText && (
											<button
												className="mr-2 ml-1 focus:outline-none focus:ring rounded-full"
												onClick={() => setSearchText("")}
											>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													fill="none"
													viewBox="0 0 24 24"
													strokeWidth="1"
													stroke="currentColor"
													className="w-6 h-6 text-gray-500"
												>
													<path
														strokeLinecap="round"
														strokeLinejoin="round"
														d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
													/>
												</svg>
											</button>
										)}
										<input
											value={searchText}
											onChange={(e) => {
												setSearchText(e.target.value);
											}}
											className="py-0.5 w-full bg-gray-900 text-sm border-b border-gray-900 text-gray-500 placeholder-gray-600 focus:outline-none focus:border-gray-500 ring-main-500"
											placeholder="Filter by message or author..."
										/>
									</div>
									<div className="overflow-y-scroll bg-gray-900">
										{dataSources &&
											Object.entries(dataSources).map(([id, data]) => {
												// if (data.provider !== "youtube") return null;

												return (
													<div key={`chat_holder_${id}`}>
														{data.res?.map((message) => {
															console.log();
															if (
																!String([
																	message.snippet?.textMessageDetails?.messageText?.toUpperCase(),
																	message.snippet?.displayMessage?.toUpperCase(),
																	message.authorDetails?.displayName?.toUpperCase(),
																]).includes(searchText?.toUpperCase())
															)
																return null;
															return (
																<SocialCue
																	key={`chat_${message.id}`}
																	size={prompter ? "xl" : "small"}
																	dataId={id}
																	chatMessage={message}
																	moderator={mod}
																	activeChatMessage={activeChatMessage}
																/>
															);
														})}
													</div>
												);
											})}
									</div>
								</div>
							)}
							<div
								className={`px-2 flex flex-col space-y-2
											${showChat ? "w-1/2" : "w-full"}
											${!showList && !showRealtime && "hidden"}
							`}
							>
								{showList && (
									<>
										<H2RHeading type="h6">List</H2RHeading>
										<div
											style={{ height: showRealtime ? "45%" : "95%" }}
											className={`overflow-y-scroll ${
												prompter ? "bg-black" : "bg-gray-900"
											}
													
										`}
										>
											<div>
												{dataSources &&
													Object.entries(dataSources).map(([id, data]) => {
														// if (data.provider !== "youtube") return null;
														if (!data.addedToProjects?.includes(projectId))
															return null;
														return (
															<div
																className="relative"
																key={`list_holder_${id}`}
															>
																{data.res?.map((message) => {
																	if (!message.listed) return null;
																	return (
																		<SocialCue
																			size={prompter ? "xl" : "small"}
																			key={`list_${message.id}`}
																			dataId={id}
																			chatMessage={message}
																			moderator={mod}
																			activeChatMessage={activeChatMessage}
																		/>
																	);
																})}
																{/* <span
																	style={{ zIndex: "1" }}
																	className="absolute flex justify-center items-center top-0 left-0 text-gray-600 text-sm"
																>
																	Use
																	<span className="transform scale-75">
																		<svg
																			className="flex justify-center w-12 h-12"
																			fill="none"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			{cueDesign("folder_add").icon}
																		</svg>
																	</span>{" "}
																	to list items here
																</span> */}
																{id && !hideButtons && (
																	<div className="p-1">
																		<H2RButton
																			size="small"
																			text="Add comment"
																			colour="dark"
																			icon={faPlus}
																			onClick={() =>
																				setShowAddCommentModal(true)
																			}
																		/>
																	</div>
																)}
																<AddSocialCommentModal
																	open={showAddCommentModal}
																	onClose={() => setShowAddCommentModal(false)}
																	dataSourceId={id}
																/>
															</div>
														);
													})}
											</div>
										</div>
									</>
								)}
								{showRealtime && (
									<>
										<H2RHeading type="h6">Realtime</H2RHeading>
										<div
											style={{ height: showList ? "35%" : "95%" }}
											className={`overflow-y-scroll
														
											`}
										>
											<div ref={autoScrollParent}>
												{dataSources &&
													Object.entries(dataSources).map(([id, data]) => {
														// if (data.provider !== "youtube") return null;
														return (
															<div key={`realtime_holder_${id}`}>
																{data.res?.map((message) => {
																	return (
																		<SocialCue
																			key={`realtime_${message.id}`}
																			size={prompter ? "xl" : "small"}
																			dataId={id}
																			chatMessage={message}
																			moderator={mod}
																			activeChatMessage={activeChatMessage}
																		/>
																	);
																})}
																<span ref={autoScrollSpan}></span>
															</div>
														);
													})}
											</div>
										</div>
									</>
								)}
							</div>
						</div>
						{!prompter && (
							<div className="mt-2 flex flex-col justify-between space-y-4">
								<H2RHeading type="h5">Active chat message</H2RHeading>
								<div className="h-20">
									{activeChatMessage &&
										activeChatMessage.map((acm) => {
											return (
												<SocialCue
													key={acm?.chat?.id}
													size={prompter ? "xl" : "large"}
													cue={acm}
													dataId={acm?.chat?.id}
													chatMessage={acm?.chat}
													listable={false}
													moderator={mod}
													activeChatMessage={acm}
												/>
											);
										})}
								</div>
							</div>
						)}
					</section>
				</Layout>
			</DocumentMeta>
		);
	}
}
